import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import APi from '@/services';
import { notification } from 'antd';
import { checkArrVal, formatNumOrSpace, checkLowUpperVal } from '@/shared/functions';
const { getBrokerageInfo, getCommissionInfo, queryRoundAddress, queryFrontContent, saveBrokerage, editCommission, editRoundAddress, updateFrontContent, delRoundAddress, } = APi.auction;
// 服务费设置
const serviceRulesData = {
    serviceCharge: 0,
    serviceTableTotal: 0,
    servicePageIndex: 1,
    servicePageSize: 20,
    servicePromptTitle: '默认服务费设置',
    serviceTableData: [],
    serviceLoading: false,
};
// 拍卖地址设置
const addressRulesData = {
    addressTableTotal: 0,
    addressPageIndex: 1,
    addressPageSize: 20,
    addressPromptTitle: '场次地址设置',
    addressTableData: [],
    addressLoading: false,
};
// 文案类设置
const writingRulesData = {
    writingTableTotal: 0,
    writingPageIndex: 1,
    writingPageSize: 20,
    writingPromptTitle: '保证金充值弹框提示',
    writingTableData: [],
    writingLoading: false,
};
// 车辆佣金设置
const commissionRulesData = {
    commissionTableTotal: 0,
    commissionPageIndex: 1,
    commissionPageSize: 20,
    commissionPromptTitle: '车辆佣金设置',
    commissionTableData: [],
    commissionLoading: false,
};
// 车辆佣金设置---新建默认比例数据
const commissionData = {
    commissionType: '',
    commissionFixedNumSubType: 'UnifiedSet',
    commissionFixedNum: '',
    commissionFixedRateNum: '',
    commissionFixedRateMin: '',
    commissionFixedRateMax: '',
    commissionRuleName: '',
    commissionFixSteps: [
        { min: 0, max: '', value: '', type: 'isMin' },
        { min: '', max: -1, value: '', type: 'isMax' },
    ],
    commissionShow: false,
    commissionEditData: {},
};
// 默认服务费设置---编辑服务费数据
const serviceData = {
    serviceType: '',
    serviceFixNum: 0,
    serviceFixSteps: [
        { min: 0, max: '', value: '', type: 'isMin' },
        { min: '', max: -1, value: '', type: 'isMax' },
    ],
    serviceShow: false,
    serviceEditData: {},
    serviceRuleName: '',
};
// 拍卖地址设置
const addressData = {
    addressShow: false,
    addressSelectData: [],
    addressEditData: {},
};
// 文案设置
const writingData = {
    writingShow: false,
    writingEditData: {},
};
const commonData = {
    searchData: {},
    activeTab: 'service',
    fixStepsInit: [
        { min: 0, max: '', value: '', type: 'isMin' },
        { min: '', max: -1, value: '', type: 'isMax' },
    ],
};
export default createStore({
    state: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, commonData), commissionRulesData), serviceRulesData), serviceData), addressRulesData), commissionData), writingRulesData), addressData), writingData),
    effects: {
        // 删除规则
        delRule(payload, { state, update }) {
            const apiUrl = payload.type === 'service' ? 'delCommissionRecord' : 'delBrokerageRecord';
            APi.auction[apiUrl]({ id: payload.record.id }).then((res) => {
                notification.success({ message: '规则删除成功' });
                this.updateTable({});
            });
        },
        // 设规则为默认值
        setRuleDefault(payload, { state, update }) {
            const apiUrl = payload.type === 'service' ? 'commissionSetDefaultTag' : 'brokerageSetDefaultTag';
            APi.auction[apiUrl]({ id: payload.record.id }).then((res) => {
                notification.success({ message: '默认规则设置成功' });
                this.updateTable({});
            });
        },
        // 异步setState
        setStateAsync(payload, { state, update }) {
            return __awaiter(this, void 0, void 0, function* () {
                const keys = Object.keys(payload);
                const values = Object.values(payload);
                yield keys.map((item, index) => {
                    update({ [item]: values[index] });
                });
            });
        },
        // 获取/更新列表数据
        updateTable(params, { state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { activeTab } = state;
                let api;
                switch (activeTab) {
                    case 'commission':
                        api = getBrokerageInfo;
                        break;
                    case 'service':
                        api = getCommissionInfo;
                        break;
                    case 'address':
                        api = queryRoundAddress;
                        break;
                    case 'writing':
                        api = queryFrontContent;
                        break;
                }
                if (api) {
                    const searchParams = {
                        pageIndex: state[`${activeTab}PageIndex`],
                        pageSize: state[`${activeTab}PageSize`],
                    };
                    api(searchParams).then((res) => {
                        const { items, totalNumber } = res;
                        this.SET_STATE({
                            [`${activeTab}TableData`]: items,
                            [`${activeTab}TableTotal`]: totalNumber,
                        });
                    });
                }
            });
        },
        linkToDetail(link) {
            const { path, query } = link;
            dispatch.router.push({
                path,
                query,
            });
        },
        // desc 重置数据
        resetState(params) {
            this.SET_STATE(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, commonData), commissionRulesData), serviceRulesData), serviceData), addressRulesData), commissionData), writingRulesData));
        },
        // 清空 服务费/佣金form
        resetForm(payload) {
            this.SET_STATE(Object.assign(Object.assign({}, serviceData), commissionData));
        },
        // desc 编辑/新建
        edit({ payload, callback }, { state, rootState }) {
            const { activeTab } = state;
            const editData = state[`${activeTab}EditData`] || {};
            const { id = '' } = editData;
            let API;
            let msg = '';
            switch (activeTab) {
                // 佣金
                case 'commission':
                    API = saveBrokerage;
                    msg = '佣金';
                    this.submitCommission(payload).then((params) => {
                        if (params) {
                            API(Object.assign({ id }, params)).then((res) => {
                                callback && callback(res, msg);
                            });
                        }
                    });
                    break;
                // 服务费
                case 'service':
                    API = editCommission;
                    msg = '服务费';
                    this.submitService(payload).then((params) => {
                        if (params) {
                            API(Object.assign({ id }, params)).then((res) => {
                                callback && callback(res, msg);
                            });
                        }
                    });
                    break;
                // 地址
                case 'address':
                    API = editRoundAddress;
                    msg = '拍卖地址';
                    this.submitAddress({ payload, editData }).then((params) => {
                        if (params) {
                            API(Object.assign({ id }, params)).then((res) => {
                                callback && callback(res, msg);
                            });
                        }
                    });
                    break;
                // 文案
                case 'writing':
                    API = updateFrontContent;
                    msg = '文案';
                    this.submitWriting(payload).then((params) => {
                        if (params) {
                            API(Object.assign({ id }, params)).then((res) => {
                                callback && callback(res, msg);
                            });
                        }
                    });
                    break;
            }
        },
        // ------------------------------------------------------
        //  --------------------------- 拍卖地址 -----------------
        // ------------------------------------------------------
        // 拍卖地址删除
        delAddressRow(rowData) {
            delRoundAddress({ id: rowData.id }).then((res) => {
                if (res) {
                    notification.success({ message: '删除成功' });
                    dispatch.auctionRules.updateTable({});
                }
            });
        },
        // 拍卖地址省市选择
        handleAddressSelect(payload, { state, update }) {
            update({ addressSelectData: payload });
        },
        // 提交地址
        submitAddress({ payload, editData }, { state, rootState }) {
            let params = {};
            params = {
                provinceId: state.addressSelectData.length > 0 ? state.addressSelectData[0].value : editData.provinceId,
                province: state.addressSelectData.length > 0 ? state.addressSelectData[0].label : editData.province,
                cityId: state.addressSelectData.length > 0 ? state.addressSelectData[1].value : editData.cityId,
                city: state.addressSelectData.length > 0 ? state.addressSelectData[1].label : editData.city,
                roundAddress: payload.roundAddress,
                longitude: payload.GDCoordinate ? payload.GDCoordinate.split(',')[0] : '',
                latitude: payload.GDCoordinate ? payload.GDCoordinate.split(',')[1] : '',
            };
            return params;
        },
        // ------------------------------------------------------
        // ---------------------------服务费 ---------------------
        // ------------------------------------------------------
        // 查询服务费配置详情
        getServiceRecord(payload, { state }) {
            APi.auction.getServiceRecord(payload).then((res) => {
                this.SET_STATE({
                    serviceType: res.commissionTag,
                    serviceFixNum: formatNumOrSpace(res.amountYuan),
                    serviceFixSteps: res.commissionFixSteps && res.commissionFixSteps.length > 0 ? res.commissionFixSteps : state.fixStepsInit,
                    serviceRuleName: res.ruleName
                });
            });
        },
        // 服务费类型切换
        changeServiceType(payload, { state, update }) {
            update({ serviceType: payload });
        },
        // 提交服务费
        submitService(payload, { state, rootState }) {
            let params = {};
            const { serviceType, serviceFixNum } = state;
            const tempServiceFixSteps = rootState.priceGradient.priceGradientSteps;
            if (serviceType === 'LADDER' && checkArrVal(tempServiceFixSteps).length) {
                notification.warn({
                    message: '区间值的最大值需要大于最小值',
                });
                return false;
            }
            params = {
                commissionTag: serviceType,
                price: serviceFixNum,
                commissionFixSteps: tempServiceFixSteps,
                ruleName: payload.serviceRuleName
            };
            return params;
        },
        // ---------------------------------------------------------
        // ------------------------ 佣金类 --------------------------
        // ---------------------------------------------------------
        // 查询佣金配置详情
        getCommissionRecord(payload, { state }) {
            APi.auction.getCommissionRecord(payload).then((res) => {
                let tempCommissionType = '';
                let tempCommissionFixedNumSubType = '';
                if (res.brokerageTag === 'FIXED') {
                    tempCommissionType = 'FixedNum';
                    tempCommissionFixedNumSubType = 'UnifiedSet';
                }
                else if (res.brokerageTag === 'FLOAT') {
                    tempCommissionType = 'FixedRate';
                    tempCommissionFixedNumSubType = 'UnifiedSet';
                }
                else {
                    tempCommissionType = 'FixedNum';
                    tempCommissionFixedNumSubType = 'StepSet';
                }
                this.SET_STATE({
                    commissionFixedRateNum: formatNumOrSpace(res.percentage),
                    commissionFixedRateMin: formatNumOrSpace(res.brokerageLowYuan),
                    commissionFixedRateMax: formatNumOrSpace(res.brokerageHighYuan),
                    commissionFixedNum: formatNumOrSpace(res.amountYuan),
                    commissionFixSteps: res.fixSteps && res.fixSteps.length > 0 ? res.fixSteps : state.fixStepsInit,
                    commissionType: tempCommissionType,
                    commissionFixedNumSubType: tempCommissionFixedNumSubType,
                    commissionRuleName: res.ruleName
                });
            });
        },
        // 佣金类型切换
        changeCommissionType(payload, { state, update }) {
            update({ commissionType: payload });
        },
        // 固定金额子类型
        changeCommissionFixedNumSubType(payload, { state, update }) {
            update({ commissionFixedNumSubType: payload });
        },
        // 固定比列的修改
        handleFixedRate(payload, { state }) {
            this.SET_STATE({
                [`commission${(payload.type)}`]: payload.value,
            });
        },
        // 提交佣金数据及校验
        submitCommission(payload, { state, rootState }) {
            let params = {};
            const { commissionType, commissionFixedNumSubType } = state;
            let tempBrokerageTag = '';
            if (commissionType === 'FixedNum' && commissionFixedNumSubType === 'UnifiedSet') {
                tempBrokerageTag = 'FIXED';
            }
            else if (commissionType === 'FixedRate') {
                tempBrokerageTag = 'FLOAT';
            }
            else {
                tempBrokerageTag = 'LADDER';
            }
            const tempCommissionFixSteps = rootState.priceGradient.priceGradientSteps;
            if (tempBrokerageTag === 'LADDER' && checkArrVal(tempCommissionFixSteps).length) {
                notification.warn({
                    message: '区间值的最大值需要大于最小值',
                });
                return false;
            }
            if (checkLowUpperVal(state.commissionFixedRateMin, state.commissionFixedRateMax)) {
                notification.warn({
                    message: '上限需大于等于下限',
                });
                return false;
            }
            params = {
                percentage: state.commissionFixedRateNum,
                brokerageLow: state.commissionFixedRateMin,
                brokerageHigh: state.commissionFixedRateMax,
                brokerageTag: tempBrokerageTag,
                amount: state.commissionFixedNum,
                brokerageFixSteps: tempCommissionFixSteps,
                ruleName: payload.commissionRuleName // 规则名称
            };
            return params;
        },
        // ---------------------------------------------------------
        // ------------------------ 文案类 --------------------------
        // ---------------------------------------------------------
        // 提交文案信息
        submitWriting(payload, { state, rootState }) {
            let params = {};
            const { contentType, content } = payload;
            params = {
                contentType,
                content,
            };
            return params;
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        // 其他规规则设置
        SHOW_EDIT(state, rowData) {
            const { activeTab } = state;
            state[`${activeTab}Show`] = true;
            state[`${activeTab}EditData`] = rowData;
        },
        HIDE_EDIT(state) {
            const { activeTab } = state;
            state[`${activeTab}Show`] = false;
        },
    },
});
